/** 4px base spacing scale. */
export const space = {
  0: '0rem',
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1rem',
  5: '1.25rem',
  6: '1.5rem',
  8: '2rem',
  10: '2.5rem',
  12: '3rem',
  16: '4rem',
  20: '5rem',
  24: '6rem',
} as const;

export const radius = {
  none: '0',
  sm: '0.375rem',
  md: '0.625rem',
  lg: '1rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  pill: '999px',
  circle: '50%',
} as const;

export const shadow = {
  none: 'none',
  xs: '0 1px 2px rgba(32, 18, 36, 0.06)',
  sm: '0 2px 6px rgba(32, 18, 36, 0.08)',
  md: '0 6px 18px rgba(32, 18, 36, 0.10)',
  lg: '0 14px 36px rgba(32, 18, 36, 0.14)',
  focus: '0 0 0 3px rgba(58, 11, 66, 0.35)',
  brandFocus: '0 0 0 3px rgba(249, 72, 113, 0.30)',
} as const;

export const breakpoint = {
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
} as const;

export const zIndex = {
  base: 0,
  sticky: 100,
  header: 200,
  dropdown: 300,
  drawer: 400,
  modal: 500,
  toast: 600,
} as const;

export const duration = { fast: '120ms', base: '200ms', slow: '320ms' } as const;
export const easing = {
  standard: 'cubic-bezier(0.2, 0, 0, 1)',
  enter: 'cubic-bezier(0, 0, 0.2, 1)',
} as const;

/** Minimum interactive target size (accessibility requirement). */
export const minTouchTarget = '44px';
